import Mixture from "../assets/snacks/Mixture.png";
import KaraBoondi from "../assets/snacks/KaraBoondi.png";
import AgraMixture from "../assets/snacks/AgraMixture.png";
import SpecialMixture from "../assets/snacks/SpecialMixture.png";
import KaraPoosa from "../assets/snacks/KaraPoosa.png";
import Biscuits from "../assets/snacks/Biscuits.png";
import VammuLinkilu from "../assets/snacks/VammuLinkilu.png";
import MasalaPeanuts from "../assets/snacks/MasalaPeanuts.png";
import MasalaCashew from "../assets/snacks/MasalaCashew.png";
import BadamGheer from "../assets/snacks/BadamGheer.png";
// import Samosa from "../assets/snacks/Samosa.png";

export const snacksData = [
  {
    name: "Mixture",
    nameTe: "మిక్చర్",
    desc: "Mixture is a popular South Indian snack made from a blend of crunchy ingredients like fried lentils, peanuts, curry leaves, and spices. It's known for its savory and spicy flavor, perfect for enjoying with tea or as a quick snack.",
    descTe: "మిక్చర్ అనేది వేయించిన పప్పులు, వేరుశనగలు, కరివేపాకు మరియు మసాలాల మిశ్రమంతో తయారు చేసిన ఒక ప్రసిద్ధ దక్షిణ భారత స్నాక్. ఇది ఘాటైన మరియు కారంగా ఉండే రుచికి ప్రసిద్ధి, టీతో లేదా త్వరిత స్నాక్‌గా ఆస్వాదించడానికి సరైనది.",
    price: 280,
    quantity: "1 kg",
    image: Mixture,
  },
  {
    name: "Kara Boondi",
    nameTe: "కారా బూంది",
    desc: "Kara Boondi is a crispy South Indian snack made from chickpea flour (besan), spices, and fried to a golden brown. Its savory, crunchy texture and spicy seasoning make it a favorite accompaniment with tea or as a snack on its own.",
    descTe: "కారా బూంది అనేది శనగపిండి, మసాలాలతో తయారు చేసి బంగారు గోధుమ రంగు వచ్చేవరకు వేయించిన కరకరలాడే దక్షిణ భారత స్నాక్. దీని ఘాటైన, కరకరలాడే ఆకృతి మరియు కారపు రుచి దీన్ని టీతో లేదా ఒంటరిగా ఆస్వాదించే ఇష్టమైన తినుబండారంగా చేస్తాయి.",
    price: 280,
    quantity: "1 kg",
    image: KaraBoondi,
  },
  {
    name: "Agra Mixture",
    nameTe: "ఆగ్రా మిక్చర్",
    desc: "Agra Mixture is a savory Indian snack known for its blend of crispy ingredients like chickpea flour noodles, peanuts, and spices. It offers a delightful crunch and spicy flavor, perfect for snacking or serving during gatherings.",
    descTe: "ఆగ్రా మిక్చర్ అనేది శనగపిండి నూడుల్స్, వేరుశనగలు మరియు మసాలాల వంటి కరకరలాడే పదార్థాల మిశ్రమానికి ప్రసిద్ధి చెందిన ఘాటైన భారతీయ స్నాక్. ఇది స్నాకింగ్‌కు లేదా సమావేశాలలో వడ్డించడానికి సరైన కరకరలాడే మరియు కారపు రుచిని అందిస్తుంది.",
    price: 280,
    quantity: "1 kg",
    image: AgraMixture,
  },
  {
    name: "Special Mixture",
    nameTe: "స్పెషల్ మిక్చర్",
    desc: "Special Mixture is a traditional Indian snack featuring a mix of crispy ingredients such as fried lentils, peanuts, sev (fried gram flour noodles), and spices. Its savory and spicy flavors make it a popular choice for tea-time snacking or festive occasions.",
    descTe: "స్పెషల్ మిక్చర్ అనేది వేయించిన పప్పులు, వేరుశనగలు, సేవ్ (వేయించిన శనగపిండి నూడుల్స్) మరియు మసాలాల వంటి కరకరలాడే పదార్థాల మిశ్రమంతో కూడిన సాంప్రదాయ భారతీయ స్నాక్. దీని ఘాటైన మరియు కారపు రుచులు దీన్ని టీ సమయపు స్నాకింగ్‌కు లేదా పండుగ సందర్భాలకు ఒక ప్రసిద్ధ ఎంపికగా చేస్తాయి.",
    price: 280,
    quantity: "1 kg",
    image: SpecialMixture,
  },
  {
    name: "Kara Poosa",
    nameTe: "కారా పూస",
    desc: "Kara Poosa is a savory South Indian snack made from rice flour and spices, deep-fried to a crispy texture. Known for its spicy flavor and crunchy bite, it's a popular choice for tea-time or as a crunchy snack.",
    descTe: "కారా పూస అనేది బియ్యప్పిండి మరియు మసాలాలతో తయారు చేసి, కరకరలాడే ఆకృతికి నూనెలో వేయించిన ఘాటైన దక్షిణ భారత స్నాక్. దీని కారపు రుచి మరియు కరకరలాడే కాటుకు ప్రసిద్ధి చెందిన ఇది, టీ సమయానికి లేదా కరకరలాడే స్నాక్‌గా ఒక ప్రసిద్ధ ఎంపిక.",
    price: 280,
    quantity: "1 kg",
    image: KaraPoosa,
  },
  {
    name: "Biscuits",
    nameTe: "బిస్కెట్లు",
    desc: "Half Moon Biscuits are delicate Indian pastries filled with sweetened coconut, nuts, and spices, shaped into crescent moons and baked to a golden brown. These treats are enjoyed for their crispy exterior and flavorful filling, often served during festive gatherings.",
    descTe: "హాఫ్ మూన్ బిస్కెట్లు తియ్యని కొబ్బరి, గింజలు మరియు మసాలాలతో నింపిన సున్నితమైన భారతీయ పేస్ట్రీలు, అర్ధచంద్రాకారంలో తయారు చేసి బంగారు గోధుమ రంగు వచ్చేవరకు కాల్చబడతాయి. ఈ తినుబండారాలను వాటి కరకరలాడే బయటి పొర మరియు రుచికరమైన నింపకం కోసం ఆస్వాదిస్తారు, తరచుగా పండుగ సమావేశాలలో వడ్డిస్తారు.",
    price: 280,
    quantity: "1 kg",
    image: Biscuits,
  },
  {
    name: "Vammu Linkilu",
    nameTe: "వాము లింకిలు",
    desc: "Linkilu is a traditional South Indian snack made from a mix of rice flour, sesame seeds, cumin seeds, and spices, deep-fried to a crisp texture. These savory, bite-sized treats are popular for their crunchy exterior and flavorful seasoning.",
    descTe: "లింకిలు అనేది బియ్యప్పిండి, నువ్వులు, జీలకర్ర మరియు మసాలాల మిశ్రమంతో తయారు చేసి కరకరలాడే ఆకృతికి నూనెలో వేయించిన సాంప్రదాయ దక్షిణ భారత స్నాక్. ఈ ఘాటైన, కొరుకుడు-పరిమాణపు తినుబండారాలు వాటి కరకరలాడే బయటి పొర మరియు రుచికరమైన మసాలా కోసం ప్రసిద్ధి.",
    price: 280,
    quantity: "1 kg",
    image: VammuLinkilu,
  },
  {
    name: "Masala Peanuts",
    nameTe: "మసాలా వేరుశనగలు",
    desc: "Masala Peanuts are a popular South Indian snack made from spiced peanuts, deep-fried to a crispy texture. Known for its spicy flavor and crunchy bite, they're a popular choice for tea-time snacking or festive occasions.",
    descTe: "మసాలా వేరుశనగలు మసాలా వేసిన వేరుశనగలతో తయారు చేసి, కరకరలాడే ఆకృతికి నూనెలో వేయించిన ఒక ప్రసిద్ధ దక్షిణ భారత స్నాక్. కారపు రుచి మరియు కరకరలాడే కాటుకు ప్రసిద్ధి చెందిన ఇవి, టీ సమయపు స్నాకింగ్‌కు లేదా పండుగ సందర్భాలకు ప్రసిద్ధ ఎంపిక.",
    price: 280,
    quantity: "1 kg",
    image: MasalaPeanuts,
  },
  {
    name: "Masala Cashew",
    nameTe: "మసాలా జీడిపప్పు",
    desc: "Masala Cashew is a traditional South Indian snack made from cashew nuts and spices, deep-fried to a crispy texture. Known for its spicy flavor and crunchy bite, it's a popular choice for tea-time snacking or festive occasions.",
    descTe: "మసాలా జీడిపప్పు జీడిపప్పు మరియు మసాలాలతో తయారు చేసి, కరకరలాడే ఆకృతికి నూనెలో వేయించిన ఒక సాంప్రదాయ దక్షిణ భారత స్నాక్. కారపు రుచి మరియు కరకరలాడే కాటుకు ప్రసిద్ధి చెందిన ఇది, టీ సమయపు స్నాకింగ్‌కు లేదా పండుగ సందర్భాలకు ప్రసిద్ధ ఎంపిక.",
    price: 1200,
    quantity: "1 kg",
    image: MasalaCashew,
  },
  {
    name: "Badam Mik",
    nameTe: "బాదం మిల్క్",
    desc: "Badam Milk is a rich and creamy Indian beverage made from milk, ground almonds (badam), sugar, and flavored with cardamom. It's served hot or cold and is cherished for its nutty flavor and nourishing qualities.",
    descTe: "బాదం మిల్క్ అనేది పాలు, బాదం పొడి, పంచదారతో తయారు చేసి ఏలకుల రుచితో కూడిన ఒక గొప్ప మరియు క్రీమీ భారతీయ పానీయం. ఇది వేడిగా లేదా చల్లగా వడ్డించబడుతుంది మరియు దాని గింజల రుచి మరియు పోషక గుణాల కోసం ఇష్టపడతారు.",
    price: 50,
    quantity: "250 ml",
    image: BadamGheer,
  },
  // ,
  // {
  //   name:"Samosa",
  //   desc:"Samosa is a popular Indian snack consisting of a crispy, triangular pastry filled with spiced potatoes, peas, and sometimes minced meat or lentils. It's enjoyed both as a street food and at home, often served with chutney or yogurt dip.",
  //   price: 10,
  //   quantity: "1 Piece",
  //   image: Samosa,
  // }
];
